// https://vuex.vuejs.org/en/actions.html
import Vue from 'vue';
import axios from 'axios';
import { errorHandler } from '@/store/modules/global_helpers';

const BASE_URI = '/api/v1/pim/attribute-values';
const BASE_URI_V2 = '/api/v2/pim/attribute-values';
const namespace = 'store.modules.attribute-values.actions';

export default {
  get({ commit, rootGetters }, { remoteCode, aRemoteCode}) {
    Vue.$log.info(`${namespace}.get.${remoteCode}.started`);
    const attribute = rootGetters['attribute/attributes'].find(a => a.remoteCOde === aRemoteCode);
    if (attribute) {
      Vue.$log.debug(`${namespace}.get.${remoteCode}.found.in.cache`);
      const av = attribute.values.find(a => a.remoteCode === remoteCode);
      if (av) {
        commit('set_attribute_av', { ...av });
        return { ...attribute };
      }
    }
    return new Promise((resolve, reject) => {
      axios
        .get(`${BASE_URI}/${remoteCode}`)
        .then(async (response) => {
          if (typeof response === 'undefined') {
            throw new TypeError(`${namespace}.${remoteCode}.not.found`);
          }
          commit('set_attribute_av', response.data.result);
          return resolve(response.data.result);
        })
        .catch((error) => {
          Vue.$log.error(error.message);
          return errorHandler(reject)(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  active({ commit }, payload) {
    Vue.$log.info(`${namespace}.active.started`);
    return new Promise((resolve, reject) => {
      axios
        .put(`${BASE_URI_V2}/${payload.remoteCode}/active`, {
          active: payload.active,
        })
        .then(async (response) => {
          if (typeof response === 'undefined') {
            throw new TypeError(`${namespace}.${payload.remoteCode}.not.found`);
          }
          commit('set_attribute_av', response.data.result);
          return resolve(response.data.result);
        })
        .catch((error) => {
          Vue.$log.error(error.message);
          return errorHandler(reject)(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  update({ commit }, payload) {
    Vue.$log.info(`${namespace}.update.started`);
    return new Promise((resolve, reject) => {
      axios
        .put(`${BASE_URI_V2}/${payload.remoteCode}`, payload)
        .then(async (response) => {
          if (typeof response === 'undefined') {
            throw new TypeError(`${namespace}.${payload.remoteCode}.not.found`);
          }
          commit('set_attribute_av', response.data.result);
          return resolve(response.data.result);
        })
        .catch((error) => {
          Vue.$log.error(error.message);
          return errorHandler(reject)(error);
        });
    });
  },
  // eslint-disable-next-line no-unused-vars
  mapping({ commit }, payload) {
    Vue.$log.info(`${namespace}.mapping.started`);
    return new Promise((resolve, reject) => {
      axios
        .put(`${BASE_URI_V2}/${payload.remoteCode}/mapping`, payload)
        .then(async (response) => {
          if (typeof response === 'undefined') {
            throw new TypeError(`${namespace}.${payload.remoteCode}.not.found`);
          }
          commit('set_attribute_av', response.data.result);
          return resolve(response.data.result);
        })
        .catch((error) => {
          Vue.$log.error(error.message);
          return errorHandler(reject)(error);
        });
    });
  },
};
